import { Outlet } from "react-router-dom";
import Header from "../../components/Header/Header";
import PanelTabs from "../../components/PanelTabs/PanelTabs";

export default function RootLayout() {
  return (
    <>
      <Header />

      <main className="primary-main">
        <section>
        <PanelTabs />
        <Outlet />
        </section>
      </main>
    </>
  );
}
